module.exports = __webpack_public_path__ + "static/media/tm-colorit-9-sm.e04ba251.webp";